// Sample questions shown in the Answer Receipt (home hero and Conversational BI).
// All figures are illustrative, and every surface using them says so.
export const SAMPLE_NOTE = 'Sample data, shown for illustration.';

export const SAMPLES = [
  {
    id: 'variance',
    q: "What's driving the variance in Engineering vs budget?",
    short: 'Engineering vs budget',
    a: 'Engineering opex exceeded Q2 budget by $420,000 (+14.2%), driven primarily by AWS Cloud Infrastructure (+$310,000) and Contractor Surge (+$110,000).',
    figuresLabel: 'Variance to Q2 budget',
    figures: [
      { label: 'AWS Cloud Infrastructure', value: '+$310,000', tone: 'over' },
      { label: 'Contractor Surge', value: '+$110,000', tone: 'over' },
    ],
    total: { label: 'Engineering opex over budget', value: '+$420,000', note: '+14.2%' },
    sql: `SELECT d.department_name,
       SUM(t.actual_amount) - SUM(b.budget_amount) AS variance
FROM transactions t
JOIN budgets b ON t.dept_id = b.dept_id
WHERE t.date BETWEEN '2026-04-01' AND '2026-06-30'
GROUP BY d.department_name;`,
    data: 'transactions, budgets',
    rowsBack: '5 summary rows',
    time: '28ms',
    reference: 'tr-8f92-eng-q2',
  },
  {
    id: 'cloud',
    q: 'Breakdown cloud spend by vendor',
    short: 'Cloud spend by vendor',
    a: 'AWS accounts for 61% of cloud spend ($780,400), followed by Snowflake at 22% ($281,200) and Datadog at 9% ($115,000).',
    figuresLabel: 'Share of cloud spend',
    figures: [
      { label: 'AWS', value: '$780,400', note: '61%' },
      { label: 'Snowflake', value: '$281,200', note: '22%' },
      { label: 'Datadog', value: '$115,000', note: '9%' },
    ],
    sql: `SELECT vendor, SUM(actual_amount) AS spend
FROM transactions
WHERE category = 'cloud_infrastructure'
GROUP BY vendor
ORDER BY spend DESC;`,
    data: 'transactions',
    rowsBack: '4 summary rows',
    time: '19ms',
    reference: 'tr-3c71-cloud-q2',
  },
  {
    id: 'drivers',
    q: 'Rank top operating expense drivers this quarter',
    short: 'Top expense drivers',
    a: 'The top three drivers are Cloud Infrastructure (+$310k), Contractor Surge (+$110k), and Travel & Events (+$64k) — together 82% of the total variance.',
    figuresLabel: 'Variance by driver',
    figures: [
      { label: 'Cloud Infrastructure', value: '+$310k', tone: 'over' },
      { label: 'Contractor Surge', value: '+$110k', tone: 'over' },
      { label: 'Travel & Events', value: '+$64k', tone: 'over' },
    ],
    total: { label: 'Share of the total variance', value: '82%' },
    sql: `SELECT category, SUM(actual_amount - budget_amount) AS driver
FROM transactions t JOIN budgets b USING (dept_id, category)
GROUP BY category
ORDER BY driver DESC
LIMIT 3;`,
    data: 'transactions, budgets',
    rowsBack: '3 summary rows',
    time: '24ms',
    reference: 'tr-b640-opex-q2',
  },
];
